import { useTranslation } from 'react-i18next';
import { Badge } from 'components/ui/badge';
import { Button } from 'components/ui/button';
import { getUserLabel } from 'features/usage/utils/usage-format';

export function UsageHeader({
  viewingUserId,
  viewingUserName,
  canViewOrgUsage,
  onBack,
}: {
  viewingUserId?: string;
  viewingUserName?: string;
  /** Admins see the organization wording; everyone else reads about their own usage. */
  canViewOrgUsage?: boolean;
  onBack: () => void;
}) {
  const { t } = useTranslation();

  return (
    <header>
      {/* Figma "Usage" header (10597:127) */}
      <div className="flex items-center gap-3">
        <h1 className="text-2xl font-medium leading-heading tracking-normal text-grey-950 dark:text-true-white">
          {t('USAGE') || 'Usage'}
        </h1>
        <span className="inline-flex items-center rounded-full border border-grey-100 px-2.5 py-1 text-xs font-medium leading-heading text-grey-600 dark:border-border dark:text-muted-foreground">
          {t('BETA')}
        </span>
      </div>
      <p className="mt-1 text-sm text-grey-500 dark:text-muted-foreground">
        {canViewOrgUsage
          ? t('USAGE_PAGE_SUBTITLE', {
              defaultValue: 'How your organization uses AI. Visible only to admins.',
            })
          : t('USAGE_PAGE_SUBTITLE_PERSONAL', {
              defaultValue: "Your plan, your credits and how you've used them.",
            })}
      </p>
      {viewingUserId && (
        <div className="mt-3 flex items-center gap-2">
          <Button
            variant="ghost"
            size="sm"
            className="h-8 px-2 text-muted-foreground"
            onClick={onBack}
          >
            {t('BACK')}
          </Button>
          <Badge variant="outline" className="w-fit rounded-md px-3 py-1 font-mono text-xs">
            {viewingUserName || getUserLabel(viewingUserId)}
          </Badge>
        </div>
      )}
    </header>
  );
}
